import { Outlet } from "react-router-dom";
import { useRouterSync } from "src/hooks/useRouterSync";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

export const RouterWrapper = () => {
  useRouterSync();

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <Outlet />
    </QueryParamProvider>
  );
};
